<div
  class="w-full flex justify-center items-center tablet:justify-end mb-4 pt-2"
>
  <p-button
    label="Update My Location"
    icon="pi pi-refresh"
    class="shadow-md phone:mr-2"
    (onClick)="updateCustomerLocation()"
    [disabled]="$spinner | async"
  />
</div>
